var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCropMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19V17H9C8.45 17 7.97917 16.8042 7.5875 16.4125C7.19583 16.0208 7 15.55 7 15V9H5V7H7V5H9V15H19V17H17V19H15ZM15 13V9H11V7H15C15.55 7 16.0208 7.19583 16.4125 7.5875C16.8042 7.97917 17 8.45 17 9V13H15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6647 7.81564L21.0486 6.4715L19.7045 5.85544L21.0476 5.2456L21.6647 3.89524L22.2818 5.2456L23.6249 5.85544L22.2807 6.4715L21.6647 7.81564ZM17.2361 4.82452L17.9349 3.28721L19.4722 2.58844L17.9349 1.88966L17.2361 0.352356L16.5373 1.88966L15 2.58844L16.5373 3.28721L17.2361 4.82452Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7999 22.4L4.5499 20.75L6.1999 20L4.5499 19.25L3.7999 17.6L3.0499 19.25L1.3999 20L3.0499 20.75L3.7999 22.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCropMagic);
export default __webpack_public_path__ + "static/media/icon-crop-magic.871f3565f91054ac2e1d18e95e7465ab.svg";
export { ForwardRef as ReactComponent };